import * as React from 'react';
import { connect } from 'react-redux';
import { goBack } from 'react-router-redux';
import {
  ButtonGroup,
  IconButton,
  Hero,
  Subtitle,
  Title,
  RouteWrapper,
  Notification,
  Icon,
} from '../../components';
import {
  cancelBooking,
  getBooking,
  payBooking,
} from '../../redux/actions/bookings';

interface Props {
  match: any;
  dispatch: Function;
}

interface State {
  isReady: boolean;
  errorMessage: string | boolean;
  booking: any;
  showNotificationForCreditNote: boolean;
  showNotificationForOneDayBooking: boolean;
  totalOutstanding: number;
}

class Route extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      isReady: false,
      errorMessage: false,
      booking: false,
      showNotificationForCreditNote: false,
      showNotificationForOneDayBooking: false,
      totalOutstanding: 0,
    };
  }

  async componentDidMount() {
    const response = await this.props.dispatch(
      getBooking(this.props.match.params.id),
    );
    if (response.data.status !== 'PENDING') {
      this.setState({
        errorMessage: 'This booking is not pending so it may not be cancelled',
      });
      return;
    }
    this.setState({ isReady: true, booking: response.data });
  }

  render() {
    const { match, dispatch } = this.props;
    return (
      <RouteWrapper
        title="Remove Booking"
        requireAuth
        requirePermission="MANAGE_BOOKINGS"
        error={this.state.errorMessage}
        ready={this.state.isReady}
      >
        <Hero className="is-danger is-fullheight has-text-centered">
          <Title large>Mark as "Did Not Attend"?</Title>
          <Subtitle>
            Marking this booking as "Did Not Attend" will free it from
            availabilities
          </Subtitle>
          <ButtonGroup>
            <IconButton
              className="button is-danger is-large is-outlined is-inverted"
              handleClick={async () => {
                const total =
                  this.state.booking.hire_cost_per_day -
                  this.state.booking.total_paid;

                if (this.state.booking.total_paid === 0) {
                  const response = await dispatch(
                    cancelBooking(match.params.id),
                  );
                  if (response.error) {
                    this.setState({ errorMessage: response.error });
                    return;
                  }
                  dispatch(goBack());
                }

                if (total === 0) {
                  this.setState({
                    showNotificationForOneDayBooking: true,
                  });
                }

                if (this.state.booking.total_paid !== 0 && total < 0) {
                  this.setState({
                    showNotificationForCreditNote: true,
                    totalOutstanding: total,
                  });
                }

                if (total > 0) {
                  // :TO DO
                  // if the total paid is less than the hire_per_day_cost
                }
              }}
              icon="calendar-times-o"
              large
            >
              Confirm Cancellation
            </IconButton>
            <IconButton
              className="button is-danger is-outlined is-large is-inverted"
              handleClick={() => dispatch(goBack())}
              icon="undo"
              large
            >
              Return
            </IconButton>
          </ButtonGroup>
          {this.state.showNotificationForOneDayBooking && (
            <Notification type="danger">
              <div>
                <Icon icon="exclamation-triangle" />{' '}
                <strong>Payment Detected</strong>
                <p>
                  A single day's hire cost of{' '}
                  <strong>£{this.state.booking.hire_cost_per_day}</strong> will
                  be deducted from the total paid amount of{' '}
                  <strong>£{this.state.booking.total_paid}</strong>.
                </p>
                <IconButton
                  icon="check-circle"
                  className="is-danger is-inverted is-outlined"
                  handleClick={async () => {
                    const response = await dispatch(
                      cancelBooking(match.params.id),
                    );
                    if (response.error) {
                      this.setState({ errorMessage: response.error });
                      return;
                    }
                    dispatch(goBack());
                  }}
                >
                  Confirm
                </IconButton>
              </div>
            </Notification>
          )}
          {this.state.showNotificationForCreditNote && (
            <Notification type="danger">
              <div>
                <Icon icon="exclamation-triangle" />{' '}
                <strong>Overpayment Detected</strong>
                <p>
                  A single day's hire cost of{' '}
                  <strong>£{this.state.booking.hire_cost_per_day}</strong> will
                  be deducted from the total paid amount of{' '}
                  <strong>£{this.state.booking.total_paid}</strong>.
                  <br />
                  According to our records, this booking is overpaid by{' '}
                  <strong>£{Math.abs(this.state.totalOutstanding)}</strong>.
                </p>
                <IconButton
                  icon="money"
                  className="is-danger is-inverted is-outlined"
                  handleClick={async () => {
                    await this.props.dispatch(
                      payBooking(this.props.match.params.id, {
                        total: Number(this.state.totalOutstanding),
                        type: 'CREDIT-NOTE',
                      }),
                    );

                    const response = await dispatch(
                      cancelBooking(match.params.id),
                    );
                    if (response.error) {
                      this.setState({ errorMessage: response.error });
                      return;
                    }
                    dispatch(goBack());
                  }}
                >
                  Resolve via Credit Note
                </IconButton>
              </div>
            </Notification>
          )}
        </Hero>
      </RouteWrapper>
    );
  }
}

export default connect()(Route);
